import { createAction } from '@reduxjs/toolkit'

export const setLockupsListToState = createAction<{ chainId: number; account: string; lockupsList: any }>(
  'lockups/setLockupsListToState',
)

export const setReportAllToState = createAction<{ reportAll: any }>('lockups/setReportAllToState')

export const setTokenInfosToState = createAction<{ tokenInfos: any; total: number }>('lockups/setTokenInfosToState')
